export const TEXT_AREA_DEFAULT_ROWS = 4;

export const TEXT_AREA_DEFAULT_MAX_LENGTH = 250;
